import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['popper', 'content', 'header', 'body', 'footer', 'arrow'];
var baseStylePopper = {
  zIndex: 10
};
var baseStyleContent = {
  '--popover-bg': "white",
  bg: 'var(--popover-bg)',
  '--popper-arrow-bg': 'var(--popover-bg)',
  '--popper-arrow-shadow-color': "gray.200",
  width: 'xs',
  border: '1px solid',
  borderColor: 'inherit',
  borderRadius: 'md',
  boxShadow: 'sm',
  zIndex: 'inherit',
  _focus: {
    outline: 0,
    boxShadow: 'outline'
  }
};
var baseStyleHeader = {
  px: 3,
  py: 2,
  borderBottomWidth: '1px'
};
var baseStyleBody = {
  px: 3,
  py: 2
};
var baseStyleFooter = {
  px: 3,
  py: 2,
  borderTopWidth: '1px'
};
var baseStyle = {
  popper: baseStylePopper,
  content: baseStyleContent,
  header: baseStyleHeader,
  body: baseStyleBody,
  footer: baseStyleFooter,
  arrow: {}
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});